const normalizeBase = (value, fallback) => {
    const raw = typeof value !== 'undefined' && value ? value : fallback;
    return raw.endsWith('/') ? raw : `${raw}/`;
};
/** CMS card APIs — Bearer fetched from wallet Keycloak token endpoint. */
export const CMS_API_BASE = normalizeBase(typeof __CMS_MFE_API_BASE__ !== 'undefined' ? __CMS_MFE_API_BASE__ : '', 'https://cms.onepay.af/');
/** Wallet / ABS APIs — account, customers, currencies (host supplies JWT in iframe mode). */
export const WALLET_API_BASE = normalizeBase(typeof __CMS_MFE_WALLET_API_BASE__ !== 'undefined' ? __CMS_MFE_WALLET_API_BASE__ : '', 'https://onepay-wallet.onepay.af/abs-api/rest/');
/** CMS service token endpoint (wallet ABS Keycloak bridge). */
export const CMS_TOKEN_URL = typeof __CMS_MFE_CMS_TOKEN_URL__ !== 'undefined' && __CMS_MFE_CMS_TOKEN_URL__
    ? __CMS_MFE_CMS_TOKEN_URL__
    : `${WALLET_API_BASE}keycloak/token`;
